export default __webpack_public_path__ + "static/media/login_new.1dda56f7.svg";